/* Park Greenport guide — Phase 6 accessibility pass applied. Maintenance 2026-08-02 (v1.1): directions note now renders from the record's directions_note field (geometry hazard note overrides where present); routing eligibility unchanged — whitelist lives in parking-geometry.js. Progressive enhancement over server-rendered metaobject content; map lazy-mounted. Namespace: pg. */
(function () {
  'use strict';
  var root = document.getElementById('pg-app');
  if (!root) return;
  var dataEl = document.getElementById('pg-data');
  if (!dataEl) return;
  var DATA;
  try { DATA = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var LOCS = DATA.locations || [];
  var DESTS = (DATA.settings && DATA.settings.destinations) || [];
  var byId = {};
  LOCS.forEach(function (l) { byId[l.id] = l; });
  var state = { dest: null, filter: 'all', view: 'home', drawerId: null };
  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var scrollMode = reducedMotion ? 'auto' : 'smooth';
  var lastFocus = null;
  var $ = function (s) { return root.querySelector(s); };
  var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
  var list = $('#pg-list'), title = $('#pg-results-title'), fallback = $('#pg-fallback');
  var search = $('#pg-search'), suggest = $('#pg-suggest'), searchEmpty = $('#pg-search-empty');
  var mapEl = $('#pg-map'), mapshell = $('#pg-mapshell');

  /* ---------- lazy map loader ---------- */
  var LCSS = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
  var LCSS_SRI = 'sha384-sHL9NAb7lN7rfvG5lfHpm643Xkcjzp4jFvuavGOndn6pjVqS6ny56CAt3nsEVT4H';
  var LJS = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
  var LJS_SRI = 'sha384-cxOPjt7s7Iz04uaHJceBmS+qpjv2JkIHNVcuOrM+YHwZOmJGBXI00mdUXEq65HTH';
  function loadCss(href, sri) {
    return new Promise(function (res, rej) {
      if (document.querySelector('link[href="' + href + '"]')) return res();
      var l = document.createElement('link');
      l.rel = 'stylesheet'; l.href = href;
      if (sri) { l.integrity = sri; l.crossOrigin = 'anonymous'; }
      l.onload = res; l.onerror = rej; document.head.appendChild(l);
    });
  }
  function loadJs(src, sri) {
    return new Promise(function (res, rej) {
      if (document.querySelector('script[src="' + src + '"]')) return res();
      var s = document.createElement('script');
      s.src = src;
      if (sri) { s.integrity = sri; s.crossOrigin = 'anonymous'; }
      s.onload = res; s.onerror = rej; document.head.appendChild(s);
    });
  }
  var geoReady = mapEl ? loadJs(mapEl.getAttribute('data-geo-js')).catch(function () {}) : Promise.resolve();
  var mapApi = null, booting = null;
  function bootMap() {
    if (!mapEl) return Promise.resolve();
    if (booting) return booting;
    booting = loadCss(LCSS, LCSS_SRI)
      .then(function () { return loadJs(LJS, LJS_SRI); })
      .then(function () { return Promise.all([geoReady, loadJs(mapEl.getAttribute('data-map-js'))]); })
      .then(function () {
        if (!mapApi && window.PG_MAP && window.PG_GEOMETRY) {
          mapApi = window.PG_MAP.mount(mapEl, {
            locations: LOCS, settings: DATA.settings, geometry: window.PG_GEOMETRY,
            onSelect: function (id) { openDrawer(id); }
          });
        }
      })
      .catch(function () { booting = null; /* placeholder text remains — weak-signal state */ });
    return booting;
  }
  if (mapEl) {
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); bootMap(); } }, { rootMargin: '400px' });
      io.observe(mapEl);
    } else { bootMap(); }
  }
  function showMapFor(id) {
    bootMap().then(function () {
      window.scrollTo({ top: mapshell.offsetTop - 8, behavior: scrollMode });
      if (mapApi) { mapApi.invalidate(); if (id) mapApi.focus(id); }
    });
  }

  /* ---------- list logic ---------- */
  function destObj(key) { for (var i = 0; i < DESTS.length; i++) if (DESTS[i].key === key) return DESTS[i]; return null; }
  function walkOf(l) { return (l.walk && l.walk[state.dest || 'main']) != null ? l.walk[state.dest || 'main'] : 99; }
  function setView(v) { state.view = v; root.setAttribute('data-view', v); window.scrollTo({ top: 0, behavior: scrollMode }); }
  function render() {
    var cards = $$('.pg-card');
    var visible = [];
    cards.forEach(function (c) {
      var l = byId[c.getAttribute('data-pg-id')];
      if (!l) return;
      var ok = true;
      if (state.filter === 'free') ok = l.cls === 'free' || l.cls === 'timed';
      if (state.filter === 'lots') ok = String(l.isLot) === 'true';
      c.hidden = !ok;
      if (ok) visible.push(c);
      var w = c.querySelector('[data-pg-walk]');
      if (w && l.walk) w.textContent = l.walk[state.dest || 'main'];
    });
    var fell = visible.length === 0;
    if (fell) { cards.forEach(function (c) { c.hidden = false; }); visible = cards; }
    if (fallback) fallback.hidden = !fell;
    visible.sort(function (a, b) {
      var la = byId[a.getAttribute('data-pg-id')], lb = byId[b.getAttribute('data-pg-id')];
      var pa = (la.cls === 'private' || la.cls === 'moto') ? 100 : 0;
      var pb = (lb.cls === 'private' || lb.cls === 'moto') ? 100 : 0;
      return (walkOf(la) + pa) - (walkOf(lb) + pb);
    });
    visible.forEach(function (c) { list.appendChild(c); });
    var best = null;
    for (var i = 0; i < visible.length; i++) {
      var l = byId[visible[i].getAttribute('data-pg-id')];
      if (l.cls !== 'private' && l.cls !== 'moto') { best = visible[i]; break; }
    }
    cards.forEach(function (c) { var el = c.querySelector('.pg-best'); if (el) el.hidden = (c !== best); });
    var d = destObj(state.dest);
    if (title) title.textContent = d ? 'Parking near ' + d.label.split(' (')[0] : 'All parking in Greenport';
  }
  function pick(key) { state.dest = key; state.filter = 'all'; syncFilterChips(); if (search) search.value = ''; hideSearchPanels(); setView('results'); render(); }
  function showAll() { state.dest = null; state.filter = 'all'; syncFilterChips(); hideSearchPanels(); setView('results'); render(); }
  function syncFilterChips() {
    $$('.pg-fchip[data-pg-filter]').forEach(function (c) {
      var on = c.getAttribute('data-pg-filter') === state.filter;
      c.classList.toggle('is-on', on);
      c.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  function hideSearchPanels() { if (suggest) suggest.hidden = true; if (searchEmpty) searchEmpty.hidden = true; }

  if (search) search.addEventListener('input', function () {
    var q = search.value.trim().toLowerCase();
    if (q.length < 2) { hideSearchPanels(); return; }
    var hits = DESTS.filter(function (d) {
      return d.label.toLowerCase().indexOf(q) !== -1 || (d.synonyms || []).some(function (s) { return s.indexOf(q) === 0 || q.indexOf(s) !== -1; });
    }).slice(0, 4);
    if (hits.length) {
      suggest.innerHTML = '';
      hits.forEach(function (d) {
        var b = document.createElement('button');
        b.type = 'button'; b.textContent = d.label;
        b.addEventListener('click', function () { pick(d.key); });
        suggest.appendChild(b);
      });
      suggest.hidden = false; searchEmpty.hidden = true;
    } else { suggest.hidden = true; searchEmpty.hidden = false; }
  });

  root.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-pg-dest],[data-pg-showall],[data-pg-showmap],[data-pg-filter],[data-pg-sources],.pg-card,#pg-back,#pg-somewhere,#pg-drawer-close,#pg-drawer-showmap,#pg-src-close,#pg-overlay,#pg-src-overlay') : null;
    if (!t) return;
    if (t.hasAttribute && t.hasAttribute('data-pg-dest')) return pick(t.getAttribute('data-pg-dest'));
    if (t.hasAttribute && t.hasAttribute('data-pg-showall')) return showAll();
    if (t.hasAttribute && t.hasAttribute('data-pg-showmap')) return showMapFor(null);
    if (t.hasAttribute && t.hasAttribute('data-pg-filter')) { state.filter = t.getAttribute('data-pg-filter'); syncFilterChips(); render(); return; }
    if (t.hasAttribute && t.hasAttribute('data-pg-sources')) return openSources();
    if (t.id === 'pg-back') return setView('home');
    if (t.id === 'pg-somewhere') { if (search) search.focus(); return; }
    if (t.id === 'pg-drawer-close' || t.id === 'pg-overlay') return closeDrawer();
    if (t.id === 'pg-drawer-showmap') { var id = state.drawerId; closeDrawer(); return showMapFor(id); }
    if (t.id === 'pg-src-close' || t.id === 'pg-src-overlay') return closeSources();
    if (t.classList && t.classList.contains('pg-card')) return openDrawer(t.getAttribute('data-pg-id'));
  });
  root.addEventListener('keydown', function (e) {
    var isCard = e.target.classList && e.target.classList.contains('pg-card');
    if ((e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') && isCard) {
      e.preventDefault();
      openDrawer(e.target.getAttribute('data-pg-id'));
    }
    if (e.key === 'Escape') { closeDrawer(); closeSources(); }
  });

  /* ---------- detail drawer ---------- */
  var drawer = $('#pg-drawer'), overlay = $('#pg-overlay');
  function openDrawer(id) {
    var l = byId[id];
    if (!l || !drawer) return;
    lastFocus = document.activeElement;
    state.drawerId = id;
    var chip = $('#pg-drawer-chip');
    chip.textContent = l.chip; chip.className = 'pg-chip pg-chip--' + l.cls;
    var acc = $('#pg-drawer-access');
    if (l.accessibleSpaces) { acc.textContent = l.accessibleSpaces + ' accessible spaces'; acc.hidden = false; } else acc.hidden = true;
    $('#pg-drawer-name').textContent = l.name;
    $('#pg-drawer-sub').textContent = l.subDetail || '';
    var d = destObj(state.dest);
    var walkBox = $('#pg-drawer-walk');
    walkBox.innerHTML = '';
    var wb = document.createElement('b'); wb.textContent = (l.walk ? l.walk[state.dest || 'main'] : '–') + ' min walk';
    var ws = document.createElement('small'); ws.textContent = ' to ' + (d ? d.label.split(' (')[0] : 'Main Street');
    walkBox.appendChild(wb); walkBox.appendChild(ws);
    var warn = $('#pg-drawer-warn');
    if (l.warning) { warn.textContent = l.warning; warn.hidden = false; } else warn.hidden = true;
    var qual = $('#pg-drawer-qual');
    if (l.qualifier) { qual.textContent = l.qualifier; qual.hidden = false; } else qual.hidden = true;
    var facts = $('#pg-drawer-facts');
    facts.innerHTML = '';
    (l.facts || []).forEach(function (f) {
      var box = document.createElement('div'); box.className = 'pg-fact';
      var k = document.createElement('div'); k.className = 'pg-fact-k'; k.textContent = f.label;
      var v = document.createElement('div'); v.className = 'pg-fact-v' + (f.positive ? ' is-good' : ''); v.textContent = f.value;
      box.appendChild(k); box.appendChild(v); facts.appendChild(box);
    });
    var ent = $('#pg-drawer-entrance');
    if (l.entrance) { ent.textContent = '\u21b3 ' + l.entrance; ent.hidden = false; } else ent.hidden = true;
    /* directions: rendered only for records whitelisted in parking-geometry.js (dataset navigate-to coordinates). Note text comes from the record's directions_note field; a geometry note (GP-07 hazard) overrides. */
    var dir = $('#pg-drawer-directions'), note = $('#pg-drawer-note');
    var R = window.PG_GEOMETRY && window.PG_GEOMETRY.routing && window.PG_GEOMETRY.routing[l.id];
    if (R) {
      dir.innerHTML = '<a class="pg-btn pg-btn--primary" target="_blank" rel="noopener" href="https://www.google.com/maps/dir/?api=1&destination=' + R.lat + ',' + R.lng + '">Directions · Google Maps</a>' +
        '<a class="pg-btn pg-btn--ghost" target="_blank" rel="noopener" href="https://maps.apple.com/?daddr=' + R.lat + ',' + R.lng + '">Apple Maps</a>';
      dir.hidden = false;
      note.textContent = R.note || l.directionsNote || '';
    } else {
      dir.hidden = true; dir.innerHTML = '';
      note.textContent = 'Directions will be enabled once this location\u2019s entrance is verified on site. Posted signs govern.';
    }
    $('#pg-drawer-verified').textContent = '\u2713 Verified ' + (l.verified || '') + ' \u00b7 signs govern';
    overlay.hidden = false; drawer.hidden = false;
    drawer.setAttribute('tabindex', '-1'); drawer.focus();
  }
  function closeDrawer() {
    if (drawer) drawer.hidden = true;
    if (overlay) overlay.hidden = true;
    state.drawerId = null;
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
    lastFocus = null;
  }

  var src = $('#pg-sources'), srcOv = $('#pg-src-overlay');
  function openSources() {
    if (!src) return;
    lastFocus = document.activeElement;
    src.hidden = false; srcOv.hidden = false;
    src.setAttribute('tabindex', '-1'); src.focus();
  }
  function closeSources() {
    if (!src || src.hidden) return;
    src.hidden = true; srcOv.hidden = true;
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
    lastFocus = null;
  }

  setView('home');
  syncFilterChips();
  render();
})();
